export const devolution = {
	expired: "Expirado",
	title: "Recargas expiradas",
	toExpire: "A expirar",
	totalExpired: "Total de recargas expiradas",
	totalToExpire: "Total de recargas a expirar",
};
